import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import logo from '../img/logo.png';

const Header = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const handleToggle = () => {
    setIsOverlayOpen(!isOverlayOpen);
  };

  const handleCloseOverlay = () => {
    setIsOverlayOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('overlay')) {
      handleCloseOverlay();
    }
  };

  return (
    <header>
      <Navbar bg="transparent" expand="lg">
        <div className='tubby-toast'>
          <Link to='/'>
            <img 
              src={logo} 
              alt='logo' 
              className='logo-image' 
            />
          </Link>
          <Link to='/'>
            <h1 className='brand'>
              tubbytoast
            </h1>
          </Link>
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />

        <Navbar.Collapse id="basic-navbar-nav" className={`ml-auto ml-auto-lg ${isOverlayOpen ? 'd-lg-none' : ''}`}>
          <Nav className="ml-auto">
            <Nav.Link as={Link} to='/about'>ABOUT</Nav.Link>
            <Nav.Link as={Link} to='/services'>SERVICES</Nav.Link>
            <Nav.Link as={Link} to='/social-media'>SOCIAL MEDIA</Nav.Link>
            <Nav.Link as={Link} to='/contact'>CONTACT</Nav.Link>
          </Nav>
        </Navbar.Collapse>

        <div className={`overlay ${isOverlayOpen ? 'active' : ''}`} onClick={handleOverlayClick}>
          <button className="overlay-close-btn" onClick={handleCloseOverlay}>X</button>
          
          <Nav className="overlay-links">
            <Nav.Link as={Link} to='/about' onClick={handleCloseOverlay}>ABOUT</Nav.Link>
            <Nav.Link as={Link} to='/services' onClick={handleCloseOverlay}>SERVICES</Nav.Link>
            <Nav.Link as={Link} to='/social-media' onClick={handleCloseOverlay}>SOCIAL MEDIA</Nav.Link>
            <Nav.Link as={Link} to='/contact' onClick={handleCloseOverlay}>CONTACT</Nav.Link>
          </Nav>
        </div>
      </Navbar>
    </header>
  );
};

export default Header;
